import protoRoot from "../proto-root";
import CommandPlayerState from "../private/CommandPlayerState";

const name = "playCommandRpcResponse";

function create({ commandId, currentTime, playing }) {
  const PlayCommandRpcResponse = protoRoot.lookupType(
    "comm.PlayCommandRpcResponse"
  );

  const response = PlayCommandRpcResponse.create({
    playerState: CommandPlayerState.create({ commandId, currentTime, playing })
  });

  return { payload: response, name };
}

export default {
  create,
  name
};

// message PlayCommandRpcResponse {
//     CommandPlayerState playerState = 1;
// }
